<main>
  <caixa-webcomponent-navigation-bar />

  <caixa-webcomponent-main-title [text]="'Relatório Comparativo de Resultados'"/>
  <bfm-monthly-comparative/>
</main>
